// Vehicle Seating Capacity Options
export const SEATING_CAPACITY_OPTIONS = [
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '8', label: '8' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '23', label: '23' }
];

// Fuel Type Options
export const FUEL_TYPE = {
  PETROL: 'petrol',
  DIESEL: 'diesel',
  HYBRID: 'hybrid',
  ELECTRIC: 'electric'
};

export const FUEL_TYPE_TEXT = {
  [FUEL_TYPE.PETROL]: 'Petrol',
  [FUEL_TYPE.DIESEL]: 'Diesel',
  [FUEL_TYPE.HYBRID]: 'Hybrid',
  [FUEL_TYPE.ELECTRIC]: 'Electric'
};

// Title/Ownership Options
export const VEHICLE_TITLE = {
  WORLDSHINE_CARE: 'worldshineCare',
  WORLDSHINE_INTERNATIONAL: 'worldshineInternational',
  WORLDSHINE_CLOVERLEAF: 'worldshineCloverleaf',
  OTHER: 'other'
};

export const VEHICLE_TITLE_TEXT = {
  [VEHICLE_TITLE.WORLDSHINE_CARE]: 'Worldshine Care LLC',
  [VEHICLE_TITLE.WORLDSHINE_INTERNATIONAL]: 'Worldshine International LLC',
  [VEHICLE_TITLE.WORLDSHINE_CLOVERLEAF]: 'Worldshine Cloverleaf LLC',
  [VEHICLE_TITLE.OTHER]: 'Other-Please Specify'
};

// Lift Equipped Options
export const LIFT_EQUIPPED = {
  YES: 'true',
  NO: 'false'
};

export const LIFT_EQUIPPED_TEXT = {
  [LIFT_EQUIPPED.YES]: 'Yes',
  [LIFT_EQUIPPED.NO]: 'No'
};

// Repair Part Name Options (common vehicle parts)
export const REPAIR_PART_NAME = {
  BRAKE_PADS: 'brakePads',
  BRAKE_ROTORS: 'brakeRotors',
  OIL_FILTER: 'oilFilter',
  AIR_FILTER: 'airFilter',
  CABIN_FILTER: 'cabinFilter',
  SPARK_PLUGS: 'sparkPlugs',
  BATTERY: 'battery',
  ALTERNATOR: 'alternator',
  STARTER_MOTOR: 'starterMotor',
  TIRES: 'tires',
  WHEEL_ALIGNMENT: 'wheelAlignment',
  SUSPENSION: 'suspension',
  SHOCKS: 'shocks',
  STRUTS: 'struts',
  TRANSMISSION_FLUID: 'transmissionFluid',
  COOLANT: 'coolant',
  POWER_STEERING_FLUID: 'powerSteeringFluid',
  WINDSHIELD_WIPERS: 'windshieldWipers',
  HEADLIGHTS: 'headlights',
  TAIL_LIGHTS: 'tailLights',
  MIRRORS: 'mirrors',
  BELTS: 'belts',
  HOSES: 'hoses',
  EXHAUST_SYSTEM: 'exhaustSystem',
  MUFFLER: 'muffler',
  CATALYTIC_CONVERTER: 'catalyticConverter',
  FUEL_PUMP: 'fuelPump',
  FUEL_FILTER: 'fuelFilter',
  WATER_PUMP: 'waterPump',
  THERMOSTAT: 'thermostat',
  RADIATOR: 'radiator',
  AC_COMPRESSOR: 'acCompressor',
  HEATER_CORE: 'heaterCore',
  CLUTCH: 'clutch',
  CV_JOINTS: 'cvJoints',
  WHEEL_BEARINGS: 'wheelBearings',
  TIE_RODS: 'tieRods',
  BALL_JOINTS: 'ballJoints',
  CONTROL_ARMS: 'controlArms',
  SWAY_BAR: 'swayBar',
  OTHER: 'other'
};

export const REPAIR_PART_NAME_TEXT = {
  [REPAIR_PART_NAME.BRAKE_PADS]: 'Brake Pads',
  [REPAIR_PART_NAME.BRAKE_ROTORS]: 'Brake Rotors',
  [REPAIR_PART_NAME.OIL_FILTER]: 'Oil Filter',
  [REPAIR_PART_NAME.AIR_FILTER]: 'Air Filter',
  [REPAIR_PART_NAME.CABIN_FILTER]: 'Cabin Filter',
  [REPAIR_PART_NAME.SPARK_PLUGS]: 'Spark Plugs',
  [REPAIR_PART_NAME.BATTERY]: 'Battery',
  [REPAIR_PART_NAME.ALTERNATOR]: 'Alternator',
  [REPAIR_PART_NAME.STARTER_MOTOR]: 'Starter Motor',
  [REPAIR_PART_NAME.TIRES]: 'Tires',
  [REPAIR_PART_NAME.WHEEL_ALIGNMENT]: 'Wheel Alignment',
  [REPAIR_PART_NAME.SUSPENSION]: 'Suspension',
  [REPAIR_PART_NAME.SHOCKS]: 'Shocks',
  [REPAIR_PART_NAME.STRUTS]: 'Struts',
  [REPAIR_PART_NAME.TRANSMISSION_FLUID]: 'Transmission Fluid',
  [REPAIR_PART_NAME.COOLANT]: 'Coolant',
  [REPAIR_PART_NAME.POWER_STEERING_FLUID]: 'Power Steering Fluid',
  [REPAIR_PART_NAME.WINDSHIELD_WIPERS]: 'Windshield Wipers',
  [REPAIR_PART_NAME.HEADLIGHTS]: 'Headlights',
  [REPAIR_PART_NAME.TAIL_LIGHTS]: 'Tail Lights',
  [REPAIR_PART_NAME.MIRRORS]: 'Mirrors',
  [REPAIR_PART_NAME.BELTS]: 'Belts',
  [REPAIR_PART_NAME.HOSES]: 'Hoses',
  [REPAIR_PART_NAME.EXHAUST_SYSTEM]: 'Exhaust System',
  [REPAIR_PART_NAME.MUFFLER]: 'Muffler',
  [REPAIR_PART_NAME.CATALYTIC_CONVERTER]: 'Catalytic Converter',
  [REPAIR_PART_NAME.FUEL_PUMP]: 'Fuel Pump',
  [REPAIR_PART_NAME.FUEL_FILTER]: 'Fuel Filter',
  [REPAIR_PART_NAME.WATER_PUMP]: 'Water Pump',
  [REPAIR_PART_NAME.THERMOSTAT]: 'Thermostat',
  [REPAIR_PART_NAME.RADIATOR]: 'Radiator',
  [REPAIR_PART_NAME.AC_COMPRESSOR]: 'A/C Compressor',
  [REPAIR_PART_NAME.HEATER_CORE]: 'Heater Core',
  [REPAIR_PART_NAME.CLUTCH]: 'Clutch',
  [REPAIR_PART_NAME.CV_JOINTS]: 'CV Joints',
  [REPAIR_PART_NAME.WHEEL_BEARINGS]: 'Wheel Bearings',
  [REPAIR_PART_NAME.TIE_RODS]: 'Tie Rods',
  [REPAIR_PART_NAME.BALL_JOINTS]: 'Ball Joints',
  [REPAIR_PART_NAME.CONTROL_ARMS]: 'Control Arms',
  [REPAIR_PART_NAME.SWAY_BAR]: 'Sway Bar',
  [REPAIR_PART_NAME.OTHER]: 'Other'
};

// Quantity Options (1-10)
export const QUANTITY_OPTIONS = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' }
];
